"use strict";

(function ($, Drupal) {
  Drupal.behaviors.accordion = {
    attach: function attach(context, settings) {
      var accordionTerm = context.querySelectorAll('.accordion-term');
      var accordionDef = context.querySelectorAll('.accordion-def'); // If javascript, hide accordion definition on load

      function jsCheck() {
        for (var i = 0; i < accordionDef.length; i++) {
          if (accordionDef[i].classList) {
            accordionDef[i].classList.add('active');
          } else {
            accordionDef[i].className += ' active';
          }
        }

        $('.accordion-term button[aria-expanded="true"]').each(function () {
          $(this).parent().addClass('is-active');
        });
      }

      jsCheck(); // Accordion Toggle
      // Mobile Click Menu Transition

      for (var i = 0; i < accordionTerm.length; i++) {
        accordionTerm[i].addEventListener('click', function (e) {
          var className = 'is-active';
          var element = this.parentElement; // Add is-active class

          if (this.classList) {
            this.classList.toggle(className);
          } else {
            var classes = this.className.split(' ');
            var existingIndex = classes.indexOf(className);

            if (existingIndex >= 0) {
              classes.splice(existingIndex, 1);
            } else {
              classes.push(className);
            }

            this.className = classes.join(' ');
          } // get height of accordionDef


          if (this.classList.contains('is-active')) {
            var contentHeight = element.querySelector('.accordion-def .card-body').clientHeight;
            element.querySelector('.accordion-def').style.height = contentHeight + 'px';
          } else {
            element.querySelector('.accordion-def').style.height = "50px";
          }

          e.preventDefault();
        });
      } // If accordion hash is in url expand accordion and go to it


      if (window.location.hash) {
        var offset = -100;
        $(window.location.hash).parent().find('.accordion-term').addClass('is-active'); // smooth scroll to the anchor id

        $('html, body').animate({
          scrollTop: $(window.location.hash).offset().top + offset + 'px'
        }, 1000, 'swing');
      }
    }
  };
})(jQuery, Drupal);